import { getBlankForm, getNewQuestionnaire, postBlankForm } from '@/entities/application/api/step2';
import { IBase } from "@ifr/form-questionnaire/src/types/Elements";
import { Module } from 'vuex';
import type ExtendedAxiosError from '@/entities/application/model/types/shared/ExtendAxiosError';

interface IStep2Store {
  json: IBase[];
}
export default <Module<IStep2Store, any>>{
  state: {
    json: [],
  },
  mutations: {
    setQuestionnaire(state, quest = []) {
      state.json = quest;
    },
  },
  actions: {
    async saveStore({ rootGetters, dispatch }, json: IBase[]) {
      const id = rootGetters.appId;
      try {
        await postBlankForm(id, json);
      } catch (e: any) {
        const error = e as ExtendedAxiosError<null>;
        error.uri = rootGetters.uri.blankForm(id);
        dispatch('setError', error, { root: true });
        throw error;
      }
    },
    async getQuestionnaire({ commit, rootGetters }, isAppStore = false) {
      const id = rootGetters.appId;
      let response;
      if (isAppStore) {
        response = await getBlankForm(id);
      }
      else {
        let idN = '';
        const params = window.localStorage.getItem('survey');
        if (params) {
          idN = 'survey=' + params;
        }
        response = await getNewQuestionnaire(id, idN);
      }

      const { data = [] } = response;

      commit('setQuestionnaire', data);

      return response;
    },
  },
  getters: {
    isJson: (state): boolean => !!state.json.length,
    json: (state): IBase[] => state.json,
  },
};
